import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/uvKj-BrJC/0/project2.0/react-anthology-frontend/ws_slinky/src/app/layout.tsx")